const vehicleTypesModel = vm => ({
  title: vm.$gettext('Vehicle Types'),
  endpoint: 'vehicle-types',
  allowNew: true,
  shared: 'semi',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'requires_documentation',
      label: vm.$gettext('Req. Documentation'),
      sortable: false,
      editable: true,
      required: false,
      type: Boolean,
      default: 1,
      description: vm.$gettext('If the vehicle needs to have documentation up to date in order to be used'),
      formatter: (value, key, item) => {
        return value === 1 ? vm.$gettext('YES') : vm.$gettext('NO')
      }
    },
    {
      key: 'is_registrable',
      label: vm.$gettext('Req. Plate'),
      sortable: false,
      editable: true,
      required: false,
      type: Boolean,
      default: 1,
      description: vm.$gettext('If the vehicle requires an identification number'),
      formatter: (value, key, item) => {
        return value === 1 ? vm.$gettext('YES') : vm.$gettext('NO')
      }
    },
    {
      key: 'max_distance_allowed',
      label: vm.$gettext('Max. Distance Allowed'),
      sortable: false,
      editable: true,
      description: vm.$gettext('Max distance allowed to the vehicle type in meters. 1000 m = 1 km')
    },
    {
      key: 'max_weight_allowed',
      label: vm.$gettext('Max. Weight Allowed'),
      sortable: false,
      editable: true,
      description: vm.$gettext('Max weight allowed to the vehicle type in grams. 1000 g = 1 kg')
    },
    {
      key: 'max_volume_allowed',
      label: vm.$gettext('Max. Volume Allowed'),
      sortable: false,
      editable: true,
      description: vm.$gettext('Max volume allowed to the vehicle type in litres. 1000 l = 1 m<sup>3</sup>')
    }
  ],
  filters: ['id', 'name']
})

export default vehicleTypesModel
